import React, { Component } from 'react';
import Slope from '../charts/slope';
// import Waypoint from 'react-waypoint';
import ReactMarkdown from 'react-markdown';
import { prepareMarkDown } from '../helpers/helpers.js';

import './results.css';
import Texts from '../data/results.json';
 
class Results extends Component {
	constructor(props) {
    super(props);
    
    this.waypointPositionChanged = this.waypointPositionChanged.bind( this );
    this.formatData = this.formatData.bind( this );
    this.outputChartFooter = this.outputChartFooter.bind( this );
    
		this.state = {
      dates: {
        separator: Math.round( new Date('2018-04-03T23:00:00').getTime() / 1000 )
      },
      coalitions: [
        {

          body: 'CasaPound Italia, Forza Nuova, Italia Agli Italiani, Fiamma Tricolore',
          global: 0,
          id: 'destra',
          post: 0,
          pre: 0,
          result: 1.3,
          title: 'Destra',
          title_short: 'Destra'
        },
        {
          id: 'sinistra',
          title: 'Sinistra',
          title_short: 'Sinistra',
          body: 'Liberi e Uguali, Sinistra e Libertà, Potere al Popolo!, Partito della Rifondazione Comunista, Partito Comunista, altri',
          result: 5,
          pre: 0,
          post: 0,
          global: 0
        },
        {
          id: 'centro-sinistra',
          title: 'Centro Sinistra',
          title_short: 'Cen. Sin.',
          body: 'Partito Democratico, +Europa, Civica Popolare, Südtiroler Volkspartei, altri',
          result: 22.8,
          pre: 0,
          post: 0,
          global: 0
        },
        {
          id: 'm5s',
          title: 'Movimento 5 Stelle',
          title_short: 'M. 5 Stelle',
          body: '',
          result: 32.6,
          pre: 0,
          post: 0,
          global: 0
        },
        {
          id: 'centro-destra',
          title: 'Centro Destra',
          title_short: 'C. Destra',
          body: 'Forza Italia, Lega, Fratelli d\'Italia, Unione Di Centro, altri',
          result: 37.2,
          pre: 0,
          post: 0,
          global: 0
        }
      ],
      total: {
        pre: 0,
        post: 0,
        global: 0
      }
    }
	}
	
	componentDidMount() {
    this.formatData();
  }

  componentDidUpdate( prevProps, prevState ) {
  }
	
	componentWillUnmount() {
	}

  formatData() {
    let coalitions = this.state.coalitions.slice(0);
    let total = Object.assign({}, this.state.total);
    for (let i=0, l=coalitions.length; i<l; i++) {
      for (let element in this.props.Data.data.timeline[ coalitions[i].id ] ) {
        coalitions[i].global += parseInt( this.props.Data.data.timeline[ coalitions[i].id ][element].activity, 10);
        if ( parseInt(this.props.Data.data.timeline[ coalitions[i].id ][element].timestamp, 10) <= this.state.dates.separator ) {
          coalitions[i].pre += parseInt( this.props.Data.data.timeline[ coalitions[i].id ][element].activity, 10);
          total.pre += parseInt( this.props.Data.data.timeline[ coalitions[i].id ][element].activity, 10);
        } else {
          coalitions[i].post += parseInt( this.props.Data.data.timeline[ coalitions[i].id ][element].activity, 10);
          total.post += parseInt( this.props.Data.data.timeline[ coalitions[i].id ][element].activity, 10);
        }
        total.global += parseInt( this.props.Data.data.timeline[ coalitions[i].id ][element].activity, 10);
      }
    }
    this.setState( { coalitions, total } );
  }

  outputChartFooter( notes ) {
    if ( notes && notes.length > 5) {
      return (
        <div className="results--chart--footer">
          <p>Include: {notes}.</p>
        </div>
      );
    }
    return null;
  }

  waypointPositionChanged( pos, step ) {
    if ( pos.currentPosition === 'inside' ) {
      this.setState( { step } );
    }
  }
	
	render() {
    return (
      <div className="results in" data-step={this.state.step} data-view={this.state.show} ref={this.charts}>
        <div className="results--legend">
          <div className="results--legend--item item" >
            <div className="item--text">
              <div className="item--text--title">
                <h1>{Texts.intro.title}</h1>
              </div>
              <div className="item--text--body">
                <ReactMarkdown source={prepareMarkDown(Texts.intro.body)} />
              </div>
            </div>
          </div>
        </div>
        <div className="results--chart">
          <div className="results--chart--wrapper">
            {this.state.coalitions.map(
              (item, index) => {
                let pre = (item.pre * 100 / this.state.total.pre);
                let post = (item.post * 100 / this.state.total.post);
                let global = (item.global * 100 / this.state.total.global);
                let max = Math.max( pre, post, global, item.result );
                let series = [
                  {
                    "end": post,
                    "id": "activity",
                    "label": "Variazione Att.",
                    "start": pre
                  },
                  {
                    "end": global,
                    "id": "global",
                    "label": "Att. globale",
                    "start": global
                  },
                  {
                    "end": item.result,
                    "id": "results",
                    "label": "Risult. Elett.",
                    "start": item.result
                  }
                ];
                let labels = ['Prima','Dopo'];
                return (
                  <div key={item.id} className={"results--chart--in " + item.id}>
                    <div className="results--chart--header">
                      <h2>{item.title}</h2>

                    </div>
                    <div className="results--chart--body">
                      <div className="results--chart--container">
                        <Slope id={item.id} title={item.title} series={series} domain={[0,50]} unit="%" labels={labels} legendPosition={(max > 25) ? 'bottom' : 'top'}/>
                      </div>
                    </div>
                    {this.outputChartFooter(item.body)}
                  </div>
                )
              }
            )}
          </div>

        </div>
      </div>
    )
	}
}

export default Results;



// WEBPACK FOOTER //
// ./src/Elezioni/dataviz/results.js